// extracted by mini-css-extract-plugin
module.exports = {"lienMenu":"MenuPrincipal_lienMenu__rdXpn","lienMenuSombre":"MenuPrincipal_lienMenuSombre__xHzPw","lienMenuActif":"MenuPrincipal_lienMenuActif__249h5"};